<template>
  <div>
    <div class="row page-title-header">
      <div class="col-12">
        <BreadCrumb 
          parentRouteName="RewardCardList" 
          :extra-items="[
            {
              text: rewardCard.title,
              to: 'RewardCardView',
              params: $route.params.reward_card_id
            },
            {
              text: '集點任務',
              to: 'RewardMissionList',
              params: $route.params.reward_card_id
            },
            {
              text: rewardMission.title
            },
            '點數紀錄'
          ]" 
        />
      </div>
    </div>
    <b-card>
      <PointLog :show-filter="false" upper-target-type="RewardMission" :upper-target-id="rewardMissionId" :prefix-file-name="rewardMission.title" />
    </b-card>
  </div>
</template>

<script>
import PointLog from "@/components/Dashboard/PointLog/PointLog.vue";
import rewardCardApi from "@/apis/reward-card";
import rewardMissionApi from "@/apis/reward-mission";
import BreadCrumb from "@/components/Dashboard/BreadCrumb";

export default {
  components: {
    PointLog,
    BreadCrumb
  },
  computed: {
    rewardCardId() {
      return this.$route.params.reward_card_id;
    },
    rewardMissionId() {
      return this.$route.params.reward_mission_id;
    },
  },
  data() {
    return {
      rewardCard: {},
      rewardMission: {},
    }
  },
  mounted() {
    this.fetchRewardCard();
    this.fetchRewardMission();
  },
  methods: {
    async fetchRewardCard() {
      const { data } = await rewardCardApi.get(this.rewardCardId);

      this.rewardCard = data.data
    },
    async fetchRewardMission() {
      const { data } = await rewardMissionApi.get(this.rewardCardId, this.rewardMissionId);

      this.rewardMission = data.data;
    },
  },
};
</script>
